import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.5 4h11M11.5 4v3.96m-1.82 5.26L7 16.5h5.96m7.08 0H23L18.5 11V4M15 18.54V26" }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      d: "m5 5 20 20",
      style: {"stroke":"var(--danger)"}
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }